// src/auth/jwt.ts
export function getJwtExp(token: string): number | null {
    try {
      const [, payload] = token.split(".");
      const data = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
      return typeof data.exp === "number" ? data.exp : null;
    } catch { return null; }
  }
  
  export function secondsUntilExp(token: string): number | null {
    const exp = getJwtExp(token);
    return exp ? exp - Math.floor(Date.now() / 1000) : null;
  }
  